import React, { useState, useEffect } from "react";
import { firestore } from "../firebase";
import { collection, /* getDocs,*/ onSnapshot } from "firebase/firestore";
import "./Projects.css";
export default function Projects() {
  const [projects, setProjects] = useState([]);

  // bez da se pokazva automatically i s getDocs
  // useEffect(()=>{
  //     const fetchProjects = async () =>{
  //         try{
  //             //tuk dostupvam "project" v bazata danni
  //             const projectsCollection=collection(firestore, 'projects');
  //             //tuk q vzimam
  //             const projectsSnapshot=await getDocs(projectsCollection);
  //             //tuk q mapvam da e za cikul
  //             const projectsData=projectsSnapshot.docs.map(doc=>({id: doc.id, ...doc.data()}));
  //             setProjects(projectsData);
  //         }catch(error)
  //         {
  //             console.error('Error fetching projects:', error);
  //         }
  //     };
  //     fetchProjects();
  // }, []);

  //sus snapshot za automatically
  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(firestore, "projects"),
      (snapshot) => {
        const projectsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProjects(projectsData);
      }
    );

    return () => unsubscribe();
  }, []);

//   // Function to format the about text
//   const formatAboutText = (text) => {
//     // max number of char per line
//     const charsPerLine = 50;
//     // split text to lines at word boundaries
//     const words = text.split(" ");
//     const lines = [];
//     let currentLine = "";
//     for (const word of words) {
//       if ((currentLine + word).length <= charsPerLine) {
//         currentLine += (currentLine === "" ? "" : " ") + word;
//       } else {
//         lines.push(currentLine);
//         currentLine = word;
//       }
//     }
//     if (currentLine !== "") {
//       lines.push(currentLine);
//     }
//     // join the lines with line breaks
//     return lines.join("\n");
//   };

  return (
    <div className="projects">
      <h1>Projects:</h1>
      <ul>
        {projects.map((project) => (
          <li key={project.id} className="project-card">
            <div className="card-container">
              <h2 className="project-name">{project.name}</h2>
              <div className="about-text">
                {project.about}
              </div>
              <div className="buttons">
                <a href={project.githubLink} target="_blank" rel="noopener noreferrer">
                  <div className="github-button">
                    <button>
                      <span className="circle1"></span>
                      <span className="circle2"></span>
                      <span className="circle3"></span>
                      <span className="circle4"></span>
                      <span className="circle5"></span>
                      <span className="text">GitHub</span>
                    </button>
                  </div>
                </a>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
